module.exports = __webpack_public_path__ + "8039c214d3b25fa78c5d19f4e6222ab0.MP3";